import router from '@/router'
import {Session} from '@/handler/session'
import {toast} from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

var Error = {
  show(error) {
    // Cancelar la confirmación de un reporte no es un error para el usuario.
    if (error?.code === 'PERSISTENT_REPORT_CANCELLED') return

    if (error.response && error.response.status === 500) {

      let errorMessage = error.response.data.error || error.response.data.original?.error
      let paginaerror = true
     
      if (errorMessage && ( errorMessage.toLowerCase().includes('usado')  
        || errorMessage.toLowerCase().includes('another'))) {
        paginaerror = false
        toast(errorMessage, {
          // Usando la variable ya limpiada y en minúsculas
          theme: 'auto',
          type: 'error',
          dangerouslyHTMLString: true,
          multiple: false,
        })
      }
      if (paginaerror) {
        router.push({name: 'Error500'})
        return false
      }
    }
    
    if (error.response && error.response.status === 401) {
      Session.removeSession()
      //-ejv-window.location.reload()
      //this.$router && this.$router.push({ name: 'Login' }) || window.location.reload()
    }

    if (error.response && error.response.status === 422) {
      const data = error.response.data
      let mensaje = data.error || data.original?.error || 'Error de validación'
      if (data.detalles) {
        const lineas = Object.values(data.detalles).flat()
        mensaje += '<br>' + lineas.join('<br>')
      }
      toast(mensaje, {
        theme: 'auto',
        type: 'error',
        dangerouslyHTMLString: true,
        multiple: false,
      })
      return
    }

    if (error.response && error.response.status === 498) {      
      toast(error.response.data.error, {
        theme: 'auto',
        type: 'error',
        dangerouslyHTMLString: true,
        multiple: false,
        //limit: 1,
      })

      setTimeout(() => {
        Session.removeSession()
        window.location.reload()
      }, 2000)
    }

    if (error.response) {
      toast(error.response.data.error || error.response.data.original?.error, {
        theme: 'auto',
        type: 'error',
        dangerouslyHTMLString: true,
        multiple: false,
        //limit: 1,
      })
    } else if (error.request) {
      // Se mando el request pero nunca llego respuesta (corte de red, timeout,
      // proxy intermedio, etc.) — no hay que mostrar el objeto XMLHttpRequest crudo.
      toast(error.message || 'No se pudo conectar con el servidor. Verifique su conexion.', {
        theme: 'auto',
        type: 'error',
        dangerouslyHTMLString: true,
        multiple: false,
        //limit: 1,
      })
    } else if (error.message) {
      toast(error.message, {
        theme: 'auto',
        type: 'error',
        dangerouslyHTMLString: true,
        multiple: false,
        //limit: 1,
      })
    } else {
      toast(error, {
        theme: 'auto',
        type: 'error',
        dangerouslyHTMLString: true,
        multiple: false,
        //limit: 1,
      })
    }
  },
}
var Success = {
  show(mensaje) {
    toast(mensaje, {
      theme: 'auto',
      type: 'success',
      dangerouslyHTMLString: true,
      multiple: false,
      //limit: 1,
    })
  },
}
var Info = {
  show(mensaje) {
    toast(mensaje, {
      theme: 'auto',
      type: 'info',
      dangerouslyHTMLString: true,
      multiple: false,
      //limit: 1,
    })
  },
}

var Warning = {
  show(mensaje) {
    toast(mensaje, {
      theme: 'auto',
      type: 'warning',
      dangerouslyHTMLString: true,
      multiple: false,
    })
  },
}

export {Error, Success, Info, Warning}
